<template>
    <nav id="navigation-global" :class="{ 'is-dark': dark }">
        <div class="is-top">
          <NavMenu :dark="dark" :menu="menu" />
          <NavMenu :dark="dark" :menu="primaryMenu" />
        </div>

        <div class="is-bottom">
          <NavMenu :dark="dark" :menu="bottomMenu" />
        </div>
    </nav>
</template>

<script setup lang="ts">

  import { computed } from "vue";

  import {
    findRouteByName,
  } from "@/internal";

  import globalMenu from '@/menus/global';
  import globalPrimaryMenu from '@/menus/global-primary';
  import NavMenu from '@/components/NavMenu.vue';
  import userMenu from '@/menus/user';
  import {useRoute, useRouter} from "vue-router";
  import type Menu from "@/use/Menu";
  import {useSystemStore} from "@/stores/SystemStore";

  const systemStore = useSystemStore();
  const route = useRoute();
  const router = useRouter();
  const toggleNavPanel = systemStore.toggleNavPanel;
  const user = {};

  const props = withDefaults(defineProps<{
    dark?: boolean,
  }>(), {
    dark: false,
  });

  const menu = computed<Menu>(() => {
    return globalMenu({
      handleFavoritesClick: () => toggleNavPanel('favorites'),
      handleSearchClick: () => toggleNavPanel('search'),
      handleAddClick: () => toggleNavPanel('add'),
      hideTitles: true,
    });
  });

  const primaryMenu = computed<Menu>(() => {
    return globalPrimaryMenu({
      user: user,
    });
  });

  const bottomMenu = computed<Menu>(() => {
    return userMenu({
      handleAccountClick: () => toggleNavPanel('account'),
      handleHelpClick: () => toggleNavPanel('help'),
      handleSystemPreferencesClick: async () => {
        const route = findRouteByName('settings/system-preferences');
        await router.push(route);
      },
      handleLogOutClick: async () => {
        const route = findRouteByName('logout');
        await router.push(route);
      },
      handleSuperClick: () => toggleNavPanel('super'),
      user: user,
      hideTitles: true,
      numUnreadNotifications: null,
    });
  });

</script>

<style lang="scss" scoped>
    #navigation-global {
        background: var(--nav-background);
        display: flex;
        height: 100%;
        flex-direction: column;
        justify-content: space-between;
        padding: 5px 12.5px;
        z-index: 2000;
    }
</style>
